(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-fs-colorflow]';
  var AUTOPLAY_DELAY = 4800;
  var MOTION_FRAME_INTERVAL = 1000 / 24;

  function initColorFlow(root) {
    if (!root || root.dataset.fsColorflowInitialized === 'true') return;

    var stage = root.querySelector('[data-fs-color-stage]');
    var preview = root.querySelector('[data-fs-color-preview]');
    var name = root.querySelector('[data-fs-color-name]');
    var meta = root.querySelector('[data-fs-color-meta]');
    var motionCanvas = root.querySelector('[data-fs-color-motion]');
    var previous = root.querySelector('[data-fs-color-prev]');
    var next = root.querySelector('[data-fs-color-next]');
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-fs-color-option]'));

    if (!stage || !preview || !options.length) return;

    root.dataset.fsColorflowInitialized = 'true';
    var activeIndex = Math.max(0, options.findIndex(function (option) {
      return option.classList.contains('is-active');
    }));
    var touchStartX = 0;
    var touchStartY = 0;
    var requestId = 0;
    var autoplayTimer = 0;
    var isVisible = false;
    var isPaused = false;
    var observer = null;
    var motionFrame = 0;
    var motionMask = null;
    var motionReady = false;
    var lastMotionDraw = 0;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayEnabled = root.dataset.fsColorflowAutoplay !== 'false';
    var optionPreloaders = [];
    var optionsPreloaded = false;

    var flowPath = null;
    var returnPath = null;

    if (motionCanvas && motionCanvas.getContext && 'Path2D' in window) {
      flowPath = new Path2D();
      flowPath.moveTo(1118, 431);
      flowPath.bezierCurveTo(1131, 371, 1144, 316, 1163, 307);
      flowPath.bezierCurveTo(1182, 299, 1186, 319, 1178, 354);
      flowPath.bezierCurveTo(1166, 410, 1152, 470, 1141, 518);
      flowPath.bezierCurveTo(1136, 544, 1143, 559, 1156, 560);
      flowPath.bezierCurveTo(1171, 562, 1179, 542, 1184, 519);
      flowPath.bezierCurveTo(1195, 464, 1207, 394, 1218, 341);
      flowPath.bezierCurveTo(1223, 317, 1237, 309, 1248, 318);
      flowPath.bezierCurveTo(1260, 329, 1254, 352, 1250, 374);
      flowPath.bezierCurveTo(1239, 432, 1218, 505, 1209, 541);
      flowPath.bezierCurveTo(1204, 562, 1210, 575, 1222, 575);
      flowPath.bezierCurveTo(1236, 575, 1242, 553, 1246, 532);
      flowPath.bezierCurveTo(1257, 470, 1267, 400, 1276, 348);
      flowPath.bezierCurveTo(1280, 326, 1293, 320, 1303, 329);
      flowPath.bezierCurveTo(1314, 339, 1308, 364, 1304, 386);
      flowPath.bezierCurveTo(1294, 443, 1277, 510, 1269, 548);
      flowPath.bezierCurveTo(1264, 570, 1270, 584, 1281, 585);
      flowPath.bezierCurveTo(1294, 585, 1302, 566, 1306, 544);
      flowPath.bezierCurveTo(1316, 489, 1324, 419, 1331, 368);
      flowPath.bezierCurveTo(1334, 344, 1347, 337, 1357, 347);
      flowPath.bezierCurveTo(1368, 358, 1360, 386, 1357, 407);
      flowPath.bezierCurveTo(1349, 458, 1337, 519, 1331, 552);
      flowPath.bezierCurveTo(1326, 576, 1331, 592, 1343, 594);
      flowPath.bezierCurveTo(1357, 596, 1364, 576, 1368, 555);
      flowPath.bezierCurveTo(1373, 527, 1375, 500, 1386, 489);
      flowPath.bezierCurveTo(1398, 478, 1409, 490, 1408, 510);
      flowPath.bezierCurveTo(1408, 537, 1396, 564, 1397, 580);
      flowPath.bezierCurveTo(1398, 595, 1417, 596, 1418, 618);
      flowPath.bezierCurveTo(1419, 638, 1404, 659, 1397, 699);

      returnPath = new Path2D();
      returnPath.moveTo(1351, 701);
      returnPath.bezierCurveTo(1354, 676, 1360, 655, 1370, 638);
      returnPath.bezierCurveTo(1380, 620, 1389, 611, 1397, 603);

      motionMask = new Image();
      motionMask.decoding = 'async';
      motionMask.onload = function () {
        motionReady = true;
        startMotion();
      };
      motionMask.src = motionCanvas.dataset.maskUrl || '';
    }

    function drawMotion(time) {
      if (!motionReady || !motionCanvas || !flowPath) return;
      if (time - lastMotionDraw < MOTION_FRAME_INTERVAL) {
        motionFrame = window.requestAnimationFrame(drawMotion);
        return;
      }
      lastMotionDraw = time;
      var context = motionCanvas.getContext('2d');
      if (!context) return;
      var scaleX = motionCanvas.width / 1672;
      var scaleY = motionCanvas.height / 941;

      context.clearRect(0, 0, motionCanvas.width, motionCanvas.height);
      context.save();
      context.scale(scaleX, scaleY);
      context.lineCap = 'round';
      context.lineJoin = 'round';
      context.shadowColor = 'rgba(255, 255, 255, .34)';
      context.shadowBlur = 9;
      context.strokeStyle = 'rgba(255, 255, 255, .24)';
      context.lineWidth = 10;
      context.setLineDash([15, 112]);
      context.lineDashOffset = -(time * .012);
      context.stroke(flowPath);
      if (returnPath) {
        context.lineDashOffset = time * .012;
        context.stroke(returnPath);
      }

      context.shadowBlur = 4;
      context.strokeStyle = 'rgba(255, 255, 255, .62)';
      context.lineWidth = 2.8;
      context.setLineDash([5, 94]);
      context.lineDashOffset = -(time * .012);
      context.stroke(flowPath);
      if (returnPath) {
        context.lineDashOffset = time * .012;
        context.stroke(returnPath);
      }
      context.restore();

      context.save();
      context.globalCompositeOperation = 'destination-in';
      context.drawImage(motionMask, 0, 0, motionCanvas.width, motionCanvas.height);
      context.restore();

      motionFrame = window.requestAnimationFrame(drawMotion);
    }

    function startMotion() {
      if (reduceMotion || !isVisible || !motionReady || motionFrame) return;
      motionFrame = window.requestAnimationFrame(drawMotion);
    }

    function stopMotion() {
      if (!motionFrame) return;
      window.cancelAnimationFrame(motionFrame);
      motionFrame = 0;
    }

    function preloadOptions() {
      if (optionsPreloaded) return;
      optionsPreloaded = true;
      optionPreloaders = options.map(function (option) {
        if (!option.dataset.colorImage) return null;
        var preload = new Image();
        preload.decoding = 'async';
        preload.src = option.dataset.colorImage;
        return preload;
      }).filter(Boolean);
    }

    function stopAutoplay() {
      if (!autoplayTimer) return;
      window.clearTimeout(autoplayTimer);
      autoplayTimer = 0;
    }

    function scheduleAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || reduceMotion || !isVisible || isPaused || document.hidden) return;
      autoplayTimer = window.setTimeout(function () {
        render(activeIndex + 1);
        scheduleAutoplay();
      }, AUTOPLAY_DELAY);
    }

    function render(index) {
      var normalized = (index + options.length) % options.length;
      var option = options[normalized];
      var imageUrl = option.dataset.colorImage;
      var currentRequest = ++requestId;

      activeIndex = normalized;
      options.forEach(function (item, itemIndex) {
        var active = itemIndex === activeIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      root.style.setProperty('--fs-flow-accent', option.dataset.colorAccent || '#11a8e2');
      if (name) name.textContent = option.dataset.colorName || '';
      if (meta) meta.textContent = option.dataset.colorMeta || '';
      root.dispatchEvent(new CustomEvent('fs:colorflow:change', {
        bubbles: true,
        detail: {
          name: option.dataset.colorName || '',
          orderValue: option.dataset.colorOrder || option.dataset.colorName || '',
          accent: option.dataset.colorAccent || '#11a8e2'
        }
      }));

      if (!imageUrl || preview.src === imageUrl) {
        preview.alt = option.dataset.colorAlt || preview.alt;
        return;
      }

      preview.classList.add('is-changing');
      var loader = new Image();
      loader.decoding = 'async';
      loader.onload = function () {
        if (currentRequest !== requestId) return;
        preview.src = imageUrl;
        preview.alt = option.dataset.colorAlt || '';
        window.requestAnimationFrame(function () {
          preview.classList.remove('is-changing');
        });
      };
      loader.onerror = function () {
        if (currentRequest === requestId) preview.classList.remove('is-changing');
      };
      loader.src = imageUrl;
    }

    function showPrevious() {
      render(activeIndex - 1);
      scheduleAutoplay();
    }

    function showNext() {
      render(activeIndex + 1);
      scheduleAutoplay();
    }

    function handleKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showPrevious();
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showNext();
      }
    }

    function handleTouchStart(event) {
      if (!event.touches || !event.touches.length) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }

    function handleTouchEnd(event) {
      if (!event.changedTouches || !event.changedTouches.length) return;
      var deltaX = event.changedTouches[0].clientX - touchStartX;
      var deltaY = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(deltaX) < 44 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      if (deltaX > 0) showPrevious();
      else showNext();
    }

    function pauseAutoplay() {
      isPaused = true;
      stopAutoplay();
    }

    function resumeAutoplay() {
      isPaused = false;
      scheduleAutoplay();
    }

    function handleVisibilityChange() {
      scheduleAutoplay();
      if (document.hidden) stopMotion();
      else startMotion();
    }

    options.forEach(function (option, index) {
      option.addEventListener('click', function () {
        render(index);
        scheduleAutoplay();
      });
    });
    if (previous) previous.addEventListener('click', showPrevious);
    if (next) next.addEventListener('click', showNext);
    stage.addEventListener('keydown', handleKeydown);
    stage.addEventListener('touchstart', handleTouchStart, { passive: true });
    stage.addEventListener('touchend', handleTouchEnd, { passive: true });
    root.addEventListener('mouseenter', pauseAutoplay);
    root.addEventListener('mouseleave', resumeAutoplay);
    root.addEventListener('focusin', pauseAutoplay);
    root.addEventListener('focusout', resumeAutoplay);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        isVisible = Boolean(entries[0] && entries[0].isIntersecting);
        scheduleAutoplay();
        if (isVisible) {
          preloadOptions();
          startMotion();
        }
        else stopMotion();
      }, { threshold: 0.28 });
      observer.observe(root);
    } else {
      isVisible = true;
      preloadOptions();
      scheduleAutoplay();
      startMotion();
    }

    root.fsColorflowCleanup = function () {
      if (previous) previous.removeEventListener('click', showPrevious);
      if (next) next.removeEventListener('click', showNext);
      stage.removeEventListener('keydown', handleKeydown);
      stage.removeEventListener('touchstart', handleTouchStart);
      stage.removeEventListener('touchend', handleTouchEnd);
      root.removeEventListener('mouseenter', pauseAutoplay);
      root.removeEventListener('mouseleave', resumeAutoplay);
      root.removeEventListener('focusin', pauseAutoplay);
      root.removeEventListener('focusout', resumeAutoplay);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      stopAutoplay();
      stopMotion();
      if (observer) observer.disconnect();
      delete root.fsColorflowCleanup;
      delete root.dataset.fsColorflowInitialized;
    };
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches(ROOT_SELECTOR)) initColorFlow(context);
    Array.prototype.forEach.call(context.querySelectorAll(ROOT_SELECTOR), initColorFlow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches && event.target.matches(ROOT_SELECTOR)
      ? event.target
      : event.target.querySelector(ROOT_SELECTOR);
    if (root && root.fsColorflowCleanup) root.fsColorflowCleanup();
  });
}());
